/* Elite Sports Equipment — product page (esh-product section), 26-9-2026.
   Gallery, variant picker, quantity, add to basket (+ "Complete your kit" extras), info tabs. */
(function () {
  'use strict';
  var root = document.querySelector('[data-esp]');
  if (!root) return;
  function $(s, c) { return (c || root).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }

  /* ---------- gallery ---------- */
  var track = $('[data-esp-track]');
  var slides = track ? $$('.esp-slide', track) : [];
  var thumbs = $$('[data-esp-thumb]');
  var counter = $('[data-esp-count]');
  var cur = 0;
  function mark(i) {
    cur = i;
    thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
  }
  function go(i, smooth) {
    if (!track || !slides.length) return;
    i = (i + slides.length) % slides.length;
    track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    mark(i);
  }
  if (track) {
    var t0 = null;
    track.addEventListener('scroll', function () {
      clearTimeout(t0);
      t0 = setTimeout(function () { var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== cur && slides[i]) mark(i); }, 60);
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-esp-thumb')); }); });
    var pv = $('[data-esp-prev]'), nx = $('[data-esp-next]');
    if (pv) pv.addEventListener('click', function () { go(cur - 1); });
    if (nx) nx.addEventListener('click', function () { go(cur + 1); });
  }

  /* ---------- variants ---------- */
  var form = document.getElementById('esp-form');
  var variants = [];
  try { variants = JSON.parse($('[data-esp-variants]').textContent); } catch (e) {}
  var idInput = $('[data-esp-id]');
  var atc = $('[data-esp-atc]');
  var fieldsets = $$('[data-esp-opt]');
  var current = null;
  variants.forEach(function (v) { if (idInput && String(v.id) === idInput.value) current = v; });

  function selected() { return fieldsets.map(function (f) { var c = f.querySelector('input:checked'); return c ? c.value : null; }); }
  function extrasCount() { return $$('[data-esp-kit-item]:checked').length; }
  function label() {
    if (!current || !current.available) return 'Sold out';
    var t = 'Add to basket';
    if (fieldsets.length) { var last = current.options[current.options.length - 1]; t += ' – ' + String(last).split(' (')[0]; }
    var n = extrasCount();
    if (n) t += ' + ' + n + ' extra' + (n > 1 ? 's' : '');
    return t;
  }
  function refreshAtc() { if (atc) { atc.textContent = label(); atc.disabled = !current || !current.available; } }
  function update(fromUser) {
    var sel = selected();
    var match = null;
    variants.forEach(function (v) { if (!match && v.options.every(function (o, i) { return o === sel[i]; })) match = v; });
    current = match;
    fieldsets.forEach(function (f, i) {
      var val = f.querySelector('[data-esp-opt-val]'); if (val) val.textContent = sel[i] || '';
      $$('input', f).forEach(function (inp) {
        var ok = variants.some(function (v) { return v.available && v.options[i] === inp.value && v.options.every(function (o, k) { return k === i || o === sel[k]; }); });
        inp.parentNode.classList.toggle('is-na', !ok);
      });
    });
    var priceEl = $('[data-esp-price]'), stock = $('[data-esp-stock]'), stockText = stock ? $('[data-esp-stock-text]', stock) : null, sku = $('[data-esp-sku]');
    if (current) {
      if (idInput) idInput.value = current.id;
      if (priceEl) priceEl.textContent = current.price;
      if (stock) {
        if (stockText) stockText.textContent = current.available ? 'In stock' : 'Sold out';
        stock.classList.toggle('is-out', !current.available);
      }
      if (sku) sku.textContent = current.sku || '–';
      if (fromUser) {
        try { var u = new URL(window.location.href); u.searchParams.set('variant', current.id); history.replaceState(history.state, '', u.pathname + u.search); } catch (e) {}
        if (current.media) { var k = -1; slides.forEach(function (s, j) { if (+s.getAttribute('data-media-id') === current.media) k = j; }); if (k > -1) go(k); }
      }
    } else if (stock) {
      if (stockText) stockText.textContent = 'Not available in this combination';
      stock.classList.add('is-out');
    }
    refreshAtc();
  }
  fieldsets.forEach(function (f) { f.addEventListener('change', function () { update(true); }); });
  if (fieldsets.length) update(false); else refreshAtc();

  /* ---------- quantity ---------- */
  var qty = $('[data-esp-qty-input]');
  $$('[data-esp-qty]').forEach(function (b) {
    b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-esp-qty'), 10)); });
  });

  /* ---------- add to basket ---------- */
  var msg = $('[data-esp-msg]');
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!current || !current.available || atc.classList.contains('is-busy')) return;
    var items = [{ id: current.id, quantity: Math.max(1, parseInt(qty.value, 10) || 1) }];
    $$('[data-esp-kit-item]:checked').forEach(function (c) { items.push({ id: +c.value, quantity: 1 }); });
    atc.classList.add('is-busy'); atc.textContent = 'Adding…'; msg.textContent = '';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        atc.classList.remove('is-busy');
        if (!res.ok) { msg.textContent = (res.body && (res.body.description || res.body.message)) || 'Could not add to basket — please try again.'; msg.className = 'esp-msg is-error'; refreshAtc(); return; }
        atc.classList.add('is-done'); atc.textContent = 'Added ✓';
        msg.innerHTML = 'Added to your basket. <a href="/cart">View basket</a>'; msg.className = 'esp-msg is-ok';
        $$('[data-esp-kit-item]:checked').forEach(function (c) { c.checked = false; });
        document.dispatchEvent(new CustomEvent('cart:update'));
        setTimeout(function () { atc.classList.remove('is-done'); refreshAtc(); }, 2200);
      })
      .catch(function () { atc.classList.remove('is-busy'); msg.textContent = 'Could not add to basket — please try again.'; msg.className = 'esp-msg is-error'; refreshAtc(); });
  });

  /* ---------- complete your kit ---------- */
  var kit = $('[data-esp-kit]'), kitList = $('[data-esp-kit-list]');
  function loadRecs(intent) {
    var u = root.getAttribute('data-recs-url') + '?product_id=' + root.getAttribute('data-product-id') + '&limit=8&intent=' + intent + '&section_id=esh-recs';
    return fetch(u).then(function (r) { return r.ok ? r.text() : ''; }).then(function (h) {
      if (!h) return [];
      var d = new DOMParser().parseFromString(h, 'text/html');
      return Array.prototype.slice.call(d.querySelectorAll('.esp-kit__item'));
    }).catch(function () { return []; });
  }
  if (kit && kitList) {
    loadRecs('complementary').then(function (items) { return items.length ? items : loadRecs('related'); }).then(function (items) {
      items = items.slice(0, 2);
      if (!items.length) return;
      items.forEach(function (li) { kitList.appendChild(document.adoptNode(li)); });
      kit.hidden = false;
      kitList.addEventListener('change', refreshAtc);
    });
  }

  /* ---------- tabs ---------- */
  var tabs = $$('.esp-tab');
  function openTab(t, focus) {
    tabs.forEach(function (x) {
      var on = x === t;
      x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1;
      var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on;
    });
    if (focus) t.focus();
  }
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { openTab(t); });
    t.addEventListener('keydown', function (e) {
      var n = null;
      if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
      if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
      if (n) { e.preventDefault(); openTab(n, true); }
    });
  });
})();
